import React, { useCallback } from 'react';
import CreateShareableLinkContext from './CreateShareableLink.context';
import { DataRoomShareableLink } from 'models/ShareableLink';
import ShareableLinkDrawer from '../../components/DataRoomDocumentsRouter/components/ShareableLinkDrawer';
import ShareableFilesSelectModal from '../../components/DataRoomDocumentsRouter/components/ShareableFilesSelectModal';
import useShareableLink from '../../hooks/useShareableLink';

type CreateShareableLinkProps = {
  onSuccessFullyCreated?: (
    link: DataRoomShareableLink,
    dataRoomShareableLinkRequestId?: string,
  ) => void;
};

const CreateShareableLink: React.FC<CreateShareableLinkProps> = (props) => {
  const { children, onSuccessFullyCreated } = props;

  const {
    selectedLink,
    modalNodes,
    isLoading,
    checkedFileIds,
    checkedFolderIds,
    initiallyCheckedNodes,
    setCheckedFileIds,
    setCheckedFolderIds,
    drawerRef,
    modalRef,
    setSelectedLink,
    openModal,
    onCloseDrawer,
    onModalFilesSelect,
  } = useShareableLink();

  const resetChecked = useCallback(() => {
    setCheckedFileIds([]);
    setCheckedFolderIds([]);
  }, [setCheckedFileIds, setCheckedFolderIds]);

  const openCreateShareableLink = useCallback(
    (fileIds: string[] = []) => {
      resetChecked();
      openModal(fileIds);
    },
    [openModal, resetChecked],
  );

  const openCreateShareableLinkWithTemplate = useCallback(
    (
      link: DataRoomShareableLink & { dataRoomShareableLinkRequestId?: string },
    ) => {
      resetChecked();
      setSelectedLink(link);
      openModal(link.fileIds);
    },
    [openModal, resetChecked, setSelectedLink],
  );

  return (
    <CreateShareableLinkContext.Provider
      value={{ openCreateShareableLink, openCreateShareableLinkWithTemplate }}
    >
      {children}

      <ShareableLinkDrawer
        ref={drawerRef}
        checkedFileIds={checkedFileIds}
        checkedFolderIds={checkedFolderIds}
        link={selectedLink}
        onFilesReselect={openModal}
        onSuccessLink={onSuccessFullyCreated}
        closeAction={onCloseDrawer}
      />

      <ShareableFilesSelectModal
        ref={modalRef}
        nodes={modalNodes}
        isLoading={isLoading}
        initiallyCheckedNodes={initiallyCheckedNodes}
        onFilesSelect={onModalFilesSelect}
      />
    </CreateShareableLinkContext.Provider>
  );
};

export default CreateShareableLink;
